import { OnboardingNotificationPreferences } from '../../views/Settings/OnboardingNotificationPreferences';

export function OnboardingNotifications() {
  return <OnboardingNotificationPreferences />;
}
